import {ColumnsConfig} from '../../../overtimeReport/ColumnsConfig'
import messageResource from '../../../../messageResource'
import OvertimeCSVPreviewHeader from './OvertimeCSVPreviewHeader'
import CSVParametersBuilder from '../CSVParametersBuilder'
import CSVParametersSection from '../CSVParametersSection'
import OvertimeCSVPreviewGroupingSection from './OvertimeCSVPreviewGroupingSection'

export default function OvertimeCSVPreviewGenerator() {}

OvertimeCSVPreviewGenerator.prototype.init = function(){
    return this;
};

OvertimeCSVPreviewGenerator.prototype.generatePreviewTable = function( reportParameters, reportParamsStringBuilder) {

    const numOfGroupingColumns = ReportPreviewUtils.countNotEmptyLevels( [
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel
    ] );
    
    let columnNames = []
    
    let numOfDataColumns = 0
    if (reportParameters.columnsConfig !== ColumnsConfig.OVERTIME_ONLY)
    {
        numOfDataColumns += 3;
        columnNames.push(messageResource.getMessage("report.overtime.csv.time_balance.scheduled"));
        if (reportParameters.showWorkingAndLeaveTime){
            numOfDataColumns += 2;
            columnNames.push(messageResource.getMessage("report.overtime.time_balance.total_reported"));
            columnNames.push(messageResource.getMessage("report.overtime.time_balance.working_time"));
            columnNames.push(messageResource.getMessage("report.overtime.time_balance.leave_time"));
        }else{
            columnNames.push(messageResource.getMessage("report.overtime.csv.time_balance.reported"));
        }
        columnNames.push(messageResource.getMessage("report.overtime.csv.time_balance.difference"));
    }

    if (reportParameters.columnsConfig !== ColumnsConfig.TIME_BALANCE_ONLY)
    {
        numOfDataColumns += 2;
        columnNames.push(messageResource.getMessage("report.overtime.csv.reported_by_user"));
        columnNames.push(messageResource.getMessage("report.overtime.csv.auto_calculated"));
    }

    const header = new OvertimeCSVPreviewHeader().init(
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel
    );

    const dataGroupingSection = new OvertimeCSVPreviewGroupingSection().init(
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        numOfDataColumns,
        2
    );

    const table = document.createElement( "table" )
    table.className = "reportCsvPreviewTable overtime";
    const tBody = document.createElement( "tbody" )
    table.appendChild( tBody );

    const totalColumnsNum = numOfGroupingColumns + numOfDataColumns
    ReportPreviewUtils.addSheetHeaderRow( tBody, totalColumnsNum );

    const paramsBuilder = new CSVParametersBuilder().init()
    paramsBuilder.addDateRangeParam( reportParameters.dateRangeSelection, reportParamsStringBuilder );
    paramsBuilder.addOvertimeUsersParam( reportParameters.userSelection, reportParamsStringBuilder );

    const parametersSection = new CSVParametersSection().init( paramsBuilder, totalColumnsNum )

    parametersSection.addRows( tBody );
    header.addRows(tBody, columnNames);
    dataGroupingSection.addRows( tBody );

    return table;
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/overtime/OvertimeCSVPreviewGenerator.js